module.exports = __webpack_public_path__ + "static/media/profile_photo_2.2a2870ae.jpeg";